import { IButtonStyles, IIconStyles, INavStyles, IStackStyles } from '@fluentui/react';
import { CorptaxBrandColor } from '../CorptaxBrandColor';
import { ICorptaxTheme } from '../ICorptaxTheme';
import { CorptaxThemeNoMenuErrorStyles } from './CorptaxThemeNoMenuErrorStyles';
import { CorptaxThemePanelContainerStyles } from './CorptaxThemePanelContainerStyles';
import { CorptaxThemePinnedContainerStyles } from './CorptaxThemePinnedContainerStyles';
import { INoMenuErrorStyles } from './INoMenuErrorStyles';
import { IPanelContainerStyles } from './IPanelContainerStyles';
import { IPinnedContainerStyles } from './IPinnedContainerStyles';
import { ISemanticSiteNavStyles } from './ISemanticSiteNavStyles';

export class CorptaxThemeSiteNavStyles implements ISemanticSiteNavStyles {
    private linkItemHeight = 37;
    private menuWidth = 315;

    private scrollbarStyles = {
        '::-webkit-scrollbar': { width: '9px', height: '6px' },
        '::-webkit-scrollbar-track': {
            borderRadius: '10px',
            background: 'rgba(0,0,0,0.05)',
        },
        '::-webkit-scrollbar-thumb': {
            borderRadius: '10px',
            background: 'rgba(0,59, 92,.7)',
            borderRight: '1px white solid',
        },
        '::-webkit-scrollbar-thumb:hover': {
            background: 'rgba(0,59, 92,.85)',
        },
        '::-webkit-scrollbar-thumb:active': {
            background: 'rgb(0,59, 92)',
        },
    };

    constructor(
        private theme: ICorptaxTheme,
        private siteHeaderHeight: number
    ) {
        this.panelContainerStyles = new CorptaxThemePanelContainerStyles(theme, this.menuWidth, this.scrollbarStyles);
        this.pinnedContainerStyles = new CorptaxThemePinnedContainerStyles(
            theme,
            this.menuWidth,
            this.scrollbarStyles,
            this.siteHeaderHeight
        );
        this.noMenuErrorStyles = new CorptaxThemeNoMenuErrorStyles(theme);
    }
    panelContainerStyles: IPanelContainerStyles;
    pinnedContainerStyles: IPinnedContainerStyles;
    noMenuErrorStyles: INoMenuErrorStyles;

    get corptaxBrand() {
        return {
            logoStyles: {
                height: '24px',
                marginTop: '4px',
            },
            logoColor: CorptaxBrandColor.Blue,
        };
    }

    get navLinkStackStyles(): IStackStyles {
        return {
            root: {
                ':hover': {
                    backgroundColor: this.theme.palette.neutralLighter,
                    '.ms-Button': {
                        color: this.theme.palette.themePrimary,
                    },
                },
            },
        };
    }

    get navLinkFavoriteButtonStyles(): IButtonStyles {
        return {
            root: { height: this.linkItemHeight, color: this.theme.palette.themePrimary },
            rootHovered: {
                backgroundColor: this.theme.extendedPalette.highlight,
            },
        };
    }

    get navLinkButtonStyles(): IButtonStyles {
        return {
            root: { height: this.linkItemHeight, color: 'transparent' },
            rootHovered: {
                backgroundColor: this.theme.extendedPalette.highlight,
                color: this.theme.palette.themePrimary,
            },
        };
    }

    get futureContentIconStyles(): IIconStyles {
        return { root: { color: this.theme.palette.redDark, marginLeft: 10, marginRight: 10 } };
    }

    get navStyles(): Partial<INavStyles> {
        return {
            root: {
                overflowY: 'visible',
                '.ms-Nav-group': {
                    borderTop: `2px solid ${this.theme.palette.neutralLight}`,
                },
                '.group-header > .ms-Nav-chevronButton': {
                    fontWeight: 'bold',
                    color: this.theme.palette.themePrimary,
                    fontSize: '14px',
                    borderBottom: 'none',
                },
            },
            navItem: {
                '.is-selected > .ms-Stack': {
                    backgroundColor: this.theme.palette.neutralLight,
                },
            },
            chevronButton: {
                height: this.linkItemHeight,
                lineHeight: this.linkItemHeight,
                paddingBottom: 0,
                paddingTop: 0,
                margin: 0,
            },
            chevronIcon: {
                color: this.theme.extendedPalette.accentDarker,
                height: this.linkItemHeight,
                fontWeight: 'bold',
                ':hover': {
                    color: this.theme.extendedPalette.accentDarker,
                },
            },
            linkText: {
                color: this.theme.palette.themePrimary,
            },
            link: {
                height: this.linkItemHeight,
            },
            groupContent: {
                marginBottom: 0,
                paddingLeft: '12px',
            },
        };
    }
}
